
import React, { useState, useEffect, useReducer, useRef, Fragment } from 'react';
import {  Col, Container, Row } from 'react-bootstrap';
import { getitemsincart } from '../../store/cart'
import { connect } from 'react-redux';
import Stepper from 'react-stepper-horizontal';
import { ProgramLoader } from '../reuse/SVG';
import {
    validatecoupon,
    validategiftcard,
    confirmedlistNonLoginUser,
    validateSlotsService,
    validateBookingService,
    confirmedCartlist,
    validateInsurance
} from '../../services/programService';
import { billingDetailService } from '../../services/otherService';
import { bookingSteps, dateFormatpaymentconfirm, isProd, provinceList } from '../../helper';
import PaymentGateway from '../payment/PaymentGateway';
import moment from 'moment';
import { getCampDetailService } from '../../services/userServices';
import { prepareQuoteData } from '../bookings/bookingHelper';
import RegistrationCancellation from '../reuse/Insurance/RegistrationCancellation';
import CancellationPolicyModal from './cancellationPolicy/CancellationPolicyModal';
import GapMedicalInsurance from '../reuse/Insurance/GapMedical';
import { INSURANCE } from '../../Enums/Enum';
import { useLocation } from 'react-router-dom';

 const PaymentConfirmation = props => {
     const location = useLocation();
     const { campId } = location.state || {};
     const [cartItems, setCartItems] = useState([]);
     const [loader, setloader] = useState(false);
     const [cartIdsarr, setCartIds] = useState([]);
     const [campssubtotal, setCampsSubtotal] = useState();
     const [grandtotal, setGrandTotal] = useState();
     const [programids, setProgramIds] = useState([]);
     const [programIDwithPr, setProgramIDwithPr] = useState([]);
     const [inValidGift, setInvalidGift] = useState(false);
     const [btnlodergit, setBtnLoaderGift] = useState(false);
     const [giftCardSuccess, setGiftCardSuccess] = useState(false);
     const [giftCartValue, setGiftCardValue] = useState();
     const [giftCartName, setGiftCardName] = useState();
     const [inValidCopuon, setInvalidCopuon] = useState(false);
     const [btnlodercopuon, setBtnLoaderCopuon] = useState(false);
     const [copuonSuccess, setCopuonSuccess] = useState(false);
     const [copuonValue, setCopuonValue] = useState();
     const [copuonName, setCopuonName] = useState();
     const copuoncodefiled = useRef();
     const giftcodefiled = useRef();
     const [policyItem, setPolicyItem] = useState(null);
     const [is_payment_split, setIs_payment_split] = useState('');
     const [allCampCodes, setAllCampCodes] = useState('');
     const [billingDetail, setBillingDetail] = useState({});
     const [insuranceState, setInsuranceState] = useState('');
     const [isInsuranceStateSelected, setIsInsuranceStateSelected] = useState(false);
     const [insuranceRender, setInsuranceRender] = useState(true);
    const [appliedCouponId, setAppliedCouponId] = useState('');

     const [acceptedInsuranceQuotes, setAcceptedInsuranceQuotes] = useState([]);
     const [insuranceTotal, setInsuranceTotal] = useState(0);
     const [validateSlots, setValidateSlots] = useState([]);
     const [isSlotAvailable, setIsSlotAvailable] = useState(false);
     const [slotAvailableMsg, setSlotAvailableMsg] = useState('');
     const [discountArr, setDiscountArr] = useState([]);
     const [isAlreadyBooked, setIsAlreadyBooked] = useState(false);
     const [totalProductsPrice, setTotalProductsPrice] = useState(0);
     const [showInsurance, setShowInsurance] = useState([])
     const [declinedInsuranceQuotes, setDeclinedInsuranceQuotes] = useState([]);
     const [failIns, setFailIns] = useState([]);
     const [quoteIds, setQuoteIds] = useState([]);
     const [insuranceQuotes, setInsuranceQuotes] = useState([]);
     const [programCode, setProgramCode] = useState([]);
     const [sourceMetadata, setSourceMetadata] = useState({});
     const [disputeStatus, setDisputeStatus] = useState('');

     const handleTestDisputeChange = (status) => {
        setDisputeStatus(prev => prev === status ? '' : status);
     }
     useEffect(() => {
        if(!insuranceRender){
            setTimeout(() => {
                setInsuranceRender(true);
            }, 100)
        }
    }, [insuranceRender])


     const calcAmount = (_data) => {
        let cartitemsDetails = _data.camps[0].programs;
        let _allCampCodes = _data.camps[0].campCode;
        let sourceMetadata = _data.sourceMetadata;
        let totalCouponDiscount = 0;
        for( const camp of _data.camps ){
            for( const program of camp.programs ){
                if( program.f_couponDiscount ){
                    const programCouponDiscount = program.f_couponDiscount;
                    totalCouponDiscount = totalCouponDiscount + programCouponDiscount;
                }
            }
        }
        setAllCampCodes(_allCampCodes);
        let cartitemspre = [];
        let precartIds = [];
        let programiDs = [];
        let programCodes = [];
        let _programIDwithPr = [];
        let _additionalExperience = [];
        let checkSlots = [];
        cartitemsDetails.map((item, i, allArray) => {
            checkSlots.push({
                programId: item.programId,
                selectedDates: item.selectedDates,
                noOfBookings: item.numberOfBooking        
            })  

            if (item.detailConfirmed === 1) {
                let myCount = allArray.filter(pro => pro.campCode === item.campCode)
                programiDs.push(item.programId);
                precartIds.push(item._id);
                programCodes.push(item.programCode);
                

                if (item.campers !== undefined) {
                    item.campers.map(camper => {

                        if (camper?.additionalExperience?.length) {
                            _additionalExperience = camper?.additionalExperience.filter(jj => jj.numberOfBooking > 0);
                        }
                    }) 
                }
                cartitemspre.push({...item, myCount: myCount.length });
            }

            _programIDwithPr.push({
                programId: item.programId,
                programCost: item.f_campRegistrationFee + item.f_taxPrice,
                additionalExperience: _additionalExperience || []
            })

        });

        // setTotalProductsPrice(_totalProductsPrice);
        setValidateSlots(checkSlots);
        setProgramIds(programiDs);
        setProgramIDwithPr(_programIDwithPr)
        setCartItems(cartitemspre);
        setCartIds(precartIds);
        setloader(false);
        setCampsSubtotal(_data.f_totalAmount);
        setGrandTotal(_data.f_totalAmount);
        setProgramCode(programCodes);
        setSourceMetadata(sourceMetadata);
        if( totalCouponDiscount > 0 ){
            setCopuonValue(`${totalCouponDiscount}`);
        }
        else{
            setCopuonValue();
        }
        // setSku(sku);
     }

     const fetchData = async (_coupon ='', _gift='') => {
        console.log(_coupon)
        const _couponCode = _coupon? _coupon : copuonName
        const _giftCard = _gift ? _gift:  giftCartName
         try {
             let confirmedListApi;

             if (props.loggedIn) {
                 let cId = `?campId=${campId}`;
                 let coupon=''
                 let _gCard =''
                 if(_couponCode){
                    coupon += `&couponCode=${_couponCode}`
                 }
                 if(_giftCard){
                    _gCard=`&giftCode=${_giftCard}`
                 }
                 const params = cId + coupon + _gCard
                 confirmedListApi = () => confirmedCartlist(params);
             } else {
                 confirmedListApi = confirmedlistNonLoginUser;
             }
             const res = await confirmedListApi();

             if (res.data.statusCode === 0) {
                 setCartItems([]);
             } else {
                 calcAmount(res.data.responseData.result);
             }
         } catch (error) {
             console.error("Error fetching data:", error);
         }
     };


    useEffect(() => {
        fetchData()

        billingDetailService().then(res => {
            if (res.data.statusCode) {
                setBillingDetail(res.data.responseData.billingDetail);
                setInsuranceState(res.data.responseData.billingDetail.state);

                if(res.data.responseData.billingDetail.state.length === 2){
                    setIsInsuranceStateSelected(false)
                }

            }
        })
    }, [props.loggedIn])



    useEffect(() => {
        if(validateSlots.length){
            validateSlotsService({programData: JSON.stringify(validateSlots)}).then(res => {
                if(res.data.statusCode){
                    if(res.data.responseData.result === 1){
                        setIsSlotAvailable(true)
                    }else{
                        setIsSlotAvailable(false);
                        setSlotAvailableMsg(res.data.responseData.message)
                    }

                }
            })
        }
    }, [validateSlots])

    useEffect(() => {
        if(insuranceQuotes.length){
            updateInsuranceQuoteDataToDB(insuranceQuotes)
        }
    }, [insuranceQuotes])


    useEffect(() => {
        if(cartItems.length){
            let cartIds  = cartItems.map(i => i._id);
            let params = {
                cartIds,
            }

            validateBookingService(params).then(res => {
                if(res.data.statusCode === 0){
                    if(res.data.error.errorCode === 55){
                        setIsAlreadyBooked(true);
                    }

                }
            })
        }
    }, [cartItems])


    const handelCopuonCode = async () => {
         setBtnLoaderCopuon(true);
         let copuncodevalue = copuoncodefiled.current.value;
         if (copuncodevalue === '') {
             setBtnLoaderCopuon(false);
         } else {

            let parms = {
                couponCode: copuncodevalue,
                programId: JSON.stringify(programids),
                programData: JSON.stringify(programIDwithPr)
             }
             const res = await  validatecoupon(parms)
                 if (res?.data?.responseData?.code === 1) {
                    setAppliedCouponId(res.data.responseData?._id)
                    let copuoncodePrice = res.data.responseData.discountMoney;
                    let _discountArr = res.data.responseData.discountArr || [];
                     setBtnLoaderCopuon(false);
                     setCopuonSuccess(true);
                    //  setCopuonValue(`${copuoncodePrice}`);
                     setDiscountArr(_discountArr);
                     setCopuonName(copuncodevalue);
                    //  (grandtot);
                     setInvalidCopuon(false);
                     fetchData(copuncodevalue, '')
                 } else {
                     setBtnLoaderCopuon(false);
                     setInvalidCopuon(true);
                     setCopuonSuccess(false);
                     setCopuonValue();
                     setCopuonName();
                    //  setGrandTotal(grandtot);
                 }
         }
     }


    const handelGiftCartCode = () => {
         setBtnLoaderGift(true);
         let giftCardvalue = giftcodefiled.current.value;
         if (giftCardvalue === '') {
             setBtnLoaderGift(false);
         }
        else {
            let parms = `?giftCode=${giftCardvalue}`;
            validategiftcard(parms).then((res) => {
                if (res.data.responseData.code === 1) {
                    setBtnLoaderGift(false);
                    setGiftCardSuccess(true);
                    setGiftCardValue(res.data.responseData.result);
                    setGiftCardName(giftCardvalue);
                    setInvalidGift(false);
                    fetchData('', giftCardvalue)
                }
                else {
                    // setGrandTotal(grandtot);
                    setBtnLoaderGift(false);
                    setInvalidGift(true);
                    setGiftCardValue()
                    setGiftCardName();
                    setGiftCardSuccess(false);
                }
            })
        }
     }



    const handleCloseModal = () => setPolicyItem(null);


    const getSelectedDates = (_all, _sel) => {
         const _res = _all.filter(el => _sel.find((id) => el._id === id));
         return _res.map(i => {
             const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
             const [sy, sm, sd] = (i.startDateFormatted || '').split('-').map(Number);
             const [ey, em, ed] = (i.endDateFormatted || '').split('-').map(Number);
             const dateStr = !sy ? '' : sy === ey
                 ? `${months[sm - 1]} ${String(sd).padStart(2, '0')} - ${months[em - 1]} ${String(ed).padStart(2, '0')}, ${sy}`
                 : `${months[sm - 1]} ${String(sd).padStart(2, '0')}, ${sy} - ${months[em - 1]} ${String(ed).padStart(2, '0')}, ${ey}`;
             return (
                 <span className='cm_selected_date' key={i._id}>
                     {dateStr}
                 </span>
             );
         });
     }

    const validateInsuranceOffers = async () => {
        const offers = document.querySelectorAll('multi-offer');
        let allValid = true; 
        
        for (const offer of offers) {
            if (offer.quotes && offer.quotes.length > 0) {
                const res = await offer.validate();
                if (!res.isValid) allValid = false;
            }
        }

        return allValid;
    }

    const updateInsuranceQuotes = (e) => {
        const timeOutId = setTimeout(() => {
                const offers = document.querySelectorAll('multi-offer');                    
                const _acceptedInsuranceOffers = [];
                const _declinedInsuranceOffers = [];
                const _qids = [];
                let insuranceTotal = 0;

                    offers.forEach(offer => {
                        if (offer.quotes && offer.quotes.length > 0) {
                            offer.style.display = 'block';
                                offer.quotes.forEach(quoteDetails => {
                                    if (quoteDetails?.selectedState === 'ACCEPTED') {
                                        const quoteData = prepareQuoteData(quoteDetails, offer)
                                        quoteData.insuranceStatus = 1; 
                                        _acceptedInsuranceOffers.push(quoteData);
                                        insuranceTotal += (quoteDetails?.quote?.total / 100);
                                        _qids.push({
                                            quote_id: quoteDetails.quote.quote_id,
                                            product: `${quoteDetails.quote.product.friendly_name}`,
                                            name : `${quoteDetails.quote.policy_holder.first_name} ${quoteDetails.quote.policy_holder.last_name}`
    
                                        })
                                    }else{
                                        const quoteData = prepareQuoteData(quoteDetails, offer)
                                        _declinedInsuranceOffers.push(quoteData);
                                    }
                                });
                        } else {
                            offer.style.display = 'none';
                        }
                    });
                    setFailIns(_qids);
                    setAcceptedInsuranceQuotes(_acceptedInsuranceOffers);
                    setDeclinedInsuranceQuotes(_declinedInsuranceOffers);
                    setInsuranceTotal(insuranceTotal);
                    setInsuranceQuotes([..._acceptedInsuranceOffers,..._declinedInsuranceOffers ])
                }, 10)
                return () => {
                    clearTimeout(timeOutId)
                }
     }
     const updateFailQuoteIds = (qId) => {
        const _qIds = [...quoteIds];
        if(!_qIds.includes(qId)){
            _qIds.push(qId);
            setQuoteIds(_qIds);
        }else{
            setQuoteIds(_qIds?.filter(i => i !== qId))
        }
    }


    const updateInsuranceQuoteDataToDB = async (quotes) => {
        const params = {
            insuranceQuotes:quotes
        }
        const res = await validateInsurance(params);
        if(res.data.statusCode){
            fetchData();
        }
    }

    
     const getTotalCampCost = (items) => {
        return Number(items.f_totalPrice.toFixed(2));
    }
    const getShowInsurance = () => {
        let query = '';
        if(props?.cartItems?.length === 1){
            query = `?campCode=${allCampCodes}&programId=${props.cartItems[0].programId}`;
        }else{
            query = `?campCode=${allCampCodes}`;
        }
        getCampDetailService(query).then(res => {
            if(res?.data?.statusCode){
              let _data = res.data.responseData.result;
                setShowInsurance(_data?.showInsurance);
            }
        })
    }

    useEffect(() => {
        if(allCampCodes){
            getShowInsurance();
        }
      
    }, [allCampCodes])

    return (
        <div className="body_container">
            {
                loader ? <div className="program_loader"><ProgramLoader /></div> :
                    <div className="container">
                        <CancellationPolicyModal item={policyItem} onClose={handleCloseModal} />


                        <div className="d-flex align-items-center justify-content-between section_header">
                            <h2>Payment Information</h2>
                        </div>
                        <div className='mb-50'>
                            <Stepper steps={bookingSteps} activeStep={3} activeColor={"#e39189"} completeColor={"#842014"}/>
                        </div>
                        <hr/>
                        {
                            cartItems?.map((items, cartIndex) => (
                                <div className="row" key={items._id}>
                                    <div className="col-xl-11">
                                        <div className="c_bor_b">

                                            <div className={`d-flex justify-content-${items.byDates === 1 ? 'center' : 'between'} date_heading`}>
                                                <span></span>
                                                <span>{items.campName} - {items.programName}</span>
                                                {items.byDates === 1 ? '' : <span>{items.startDateFormatted} to {items.endDateFormatted} </span>}
                                                {/* {items.byDates === 1 ? '' : <span>{dateFormatpaymentconfirm(items.startDate)} to {dateFormatpaymentconfirm(items.endDate)}</span>} */}
                                            </div>

                                            {
                                                items.byDates === 1 ? (
                                                    <div className="d-flex">
                                                        <p className='me-3 mb-0'>Program Dates:</p>
                                                        <p className='mb-0'>{getSelectedDates(items.additionalDates, items.selectedDates)}</p> 
                                                    </div>
                                                ) : ''
                                            }
                                            <div className='d-flex flex-wrap justify-content-between'>
                                            <div className='flex-wrap flex-column flex-md-row mb-2'>
                                                {items.campers.map(cp =>
                                                    <p className='rounded-pill bg-success me-2 mb-2'><small  className='p-3 text-white'> {cp.camperName}</small></p>
                                                )}
                                            </div>
                                            <div>
                                            {
                                                items.byDates !== 1 ? <div className="d-flex justify-content-end">
                                                <p>Program Cost:</p><b>${(items.f_campRegistrationFee).toFixed(2)}</b>
                                            </div> : <div className="d-flex justify-content-end">
                                                <p>Program Cost:</p><b>${items.f_campRegistrationFee.toFixed(2)}</b>
                                            </div>
                                            }

                                            

                                            {
                                            
                                                // items.byDates !== 1 // show if non 0 
                                                // && 
                                                items.f_registerNonRefundFee 
                                                ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Non Refundable Registration Amount: </p><b>${items.f_registerNonRefundFee.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

{
                                                items.f_additionalTotal ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Additional Experience Total:</p><b>${items.f_additionalTotal.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                            <div className="d-flex justify-content-end">
                                                <p>Convenience Fee:</p><b>${items.f_convenienceFee.toFixed(2)}</b>
                                            </div>

                                            {
                                                items.f_taxPrice ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Taxes:</p><b>${items.f_taxPrice.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                                
                                            {/* Two different discounts, previously summed under one
                                                "Additional Discount" heading. f_discountPrice is the
                                                program discount the director configured — the same
                                                figure CamperDetail labels "Program Discount" — while
                                                f_additionalDiscount comes from the answers a parent
                                                gave to the program's questions. A parent owed both
                                                could not tell where either came from. */}
                                            {
                                                items.f_discountPrice ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Program Discount:</p><b>-${items.f_discountPrice.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                            {
                                                items.f_additionalDiscount ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Additional Discount:</p><b>-${items.f_additionalDiscount.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }


                                            {
                                                items.f_siblingDiscount ? (
                                                    <div className="d-flex justify-content-end">
                                                            <p>Sibling Discount:</p><b>-${items.f_siblingDiscount.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                            {
                                                items.f_multiProgramDiscount ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Multi Programs Discount:</p><b>-${items.f_multiProgramDiscount.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                            {/* The API already subtracts this program's share of the
                                                coupon from f_totalPrice; without the row the lines above
                                                Total Due don't add up to it. */}
                                            {
                                                items.f_couponDiscount ? (
                                                    <div className="d-flex justify-content-end">
                                                        <p>Coupon Discount:</p><b>-${items.f_couponDiscount.toFixed(2)}</b>
                                                    </div>
                                                ) : ''
                                            }

                                            

                                            {
                                                items?.associatedCartInfo?.length ? <ul>
                                                    {
                                                        items?.associatedCartInfo.map(({title, price, count, itemId, subItems}) => (
                                                            <>
                                                            <div key={itemId} className="d-flex justify-content-end">
                                                                <p>{title} ( {count} × ${price} ):</p><b>${(count * price).toFixed(2)}</b>
                                                            </div>
                                                                <>
                                                                    {subItems?.length ?
                                                                        subItems?.map((si) => 
                                                                            <div key={itemId} className="d-flex justify-content-end"><br/><p>{si.title} ( {si.count} × ${si.price} ):</p><b>${(si.count * si.price).toFixed(2)}</b></div>
                                                                        ) : ''
                                                                    }
                                                                </>
                                                            </>
                                                        ))
                                                    }
                                                </ul> : ''
                                            }
                                            <hr />
                                            <div className="d-flex justify-content-end">
                                                <p><strong>Total Due:</strong></p>
                                                <b>${getTotalCampCost(items).toFixed(2)}</b>
                                            </div>
                                         </div>
                                         </div>


                                            <div className="d-flex justify-content-between">
                                                <p><small>Payment for required items is due when the Program is purchased, and will be included in today’s total</small></p>
                                                <div><button className="btn btn-secondary btn-sm cp_btn" onClick={() => setPolicyItem(items)}>Cancellation Policy</button> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            ))
                        }
                         <div className="row">
                            <div className="col-xl-11">
                                <div className="c_bor_b">

                                    <h4>Coupons & Rewards</h4>
                                    <p><small>If you have a Coupon, or Rewards Code enter it here to redeem.</small></p>
                                    <div className="d-flex flex-column flex-md-row justify-content-end align-items-center">
                                        <label className="m-1">Enter Code:</label>
                                        <div className="position-relative m-1">
                                            <input onChange={() => { setInvalidCopuon(false) }} type="text" ref={copuoncodefiled} placeholder="Enter Coupon Code" className="form-control w-auto ms-2 me-2" />
                                            {inValidCopuon && <span className="cm_err_msg2">Invalid Coupon Code</span>}
                                        </div>
                                        <button onClick={handelCopuonCode} className={`btn btn-primary m-1 ps-5 pe-5 ${btnlodercopuon ? 'btnLoader' : ''}`}>Apply</button>
                                    </div>

                                    {copuonSuccess && <p className="cm_success_msg">Coupon Applied Successfully</p>}

                                </div>
                            </div>
                        </div>



                        <div className="row">
                            <div className="col-xl-11">
                                <div className="c_bor_b">

                                    <h4>Gift Card</h4>
                                    <p><small>If you have a Gift Card  Code enter it here to redeem.</small></p>

                                    <div className="d-flex flex-column flex-md-row justify-content-end align-items-center">

                                        <label className="m-1">Enter Code:</label>
                                        <div className="position-relative m-1">
                                            <input onChange={() => { setInvalidGift(false) }} ref={giftcodefiled} type="text" placeholder="Enter Gift Card Code" className="form-control w-auto ms-2 me-2" />
                                            {inValidGift && <span className="cm_err_msg2">Invalid Gift Card</span>}
                                        </div>
                                        <button onClick={handelGiftCartCode} className={`btn btn-primary m-1 ps-5 pe-5 ${btnlodergit ? 'btnLoader' : ''}`}>Apply</button>
                                    </div>
                                    {giftCardSuccess && <p className="cm_success_msg">Gift Card Applied Successfully</p>}

                                </div>
                            </div>
                        </div>
                        {!isProd() &&
                        <div className="row">
                            <div className="col-xl-11">
                                <div className="c_bor_b">
                                    <h4>Test Dispute (Dev Only)</h4>
                                    <p><small>For testing purposes only. Selecting one will simulate a chargeback dispute with the chosen outcome.</small></p>
                                    <div className="check_box_wrapper cm_dark_check">
                                        <input
                                            type="checkbox"
                                            checked={disputeStatus === 'won'}
                                            onChange={() => handleTestDisputeChange('won')} />
                                        <span className="check_box"><span></span> Create test dispute status won</span>
                                    </div>
                                    <div className="check_box_wrapper cm_dark_check">
                                        <input
                                            type="checkbox"
                                            checked={disputeStatus === 'lost'}
                                            onChange={() => handleTestDisputeChange('lost')} />
                                        <span className="check_box"><span></span> Create test dispute status lost</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        {showInsurance?.length > 0 && showInsurance?.filter(i => i.isShowInsurance === true)?.length > 0  &&
                        <div className="row">
                            <div className="col-xl-11">
                                <div className="c_bor_b">

                                    {
                                        showInsurance && !isInsuranceStateSelected ? <div className='row mb-4 mt-4'>
                                            <div className='col-md-8'>
                                                <p>Please select state for insurance</p>
                                            </div>
                                            <div className='col-md-4'>
                                                <select
                                                    value={insuranceState}
                                                    onChange={e => (setInsuranceState(e.target.value), setInsuranceRender(false))}
                                                    className={`form-control`} >
                
                                                    <option value="">Select State/Province</option>   
                                                        {provinceList.map((item, index) => (
                                                                <option value={item.value} key={index}>
                                                                {item.value} - {item.label}
                                                                </option>
                                                            ))}
                                                </select> 
                                            </div>
                                        </div> : ''
                                    }
                                    <div>
                                            {
                                                insuranceRender && insuranceState.length === 2 && props?.userProfile?.email && props?.userProfile?.lastName ? 
                                                <Container>
                                                    <Col>
                                                        {showInsurance.find(i => i.name === INSURANCE.REGISTRATION_CANCELLATION_INSURANCE).isShowInsurance && 
                                                            <Row className='position-relative '>
                                                                <RegistrationCancellation    
                                                                    updateInsuranceQuotes ={updateInsuranceQuotes} 
                                                                    allPrograms={cartItems} 
                                                                    camperList={props?.camperList} 
                                                                    insuranceState={insuranceState} 
                                                                    userEmail={props?.userProfile?.email} 
                                                                    userName={props?.userProfile?.name} 
                                                                    userLastName={props?.userProfile?.lastName} 
                                                                    billingDetail={billingDetail}
                                                                />
                                                            </Row>
                                                        }
                                                        <br/>
                                                        {
                                                            showInsurance.find(i => i.name === INSURANCE.GAP_MEDICAL_INSURANCE).isShowInsurance &&
                                                            <Row className='position-relative'>
                                                                <GapMedicalInsurance
                                                                updateInsuranceQuotes ={updateInsuranceQuotes} 
                                                                allPrograms={cartItems} 
                                                                camperList={props?.camperList} 
                                                                insuranceState={insuranceState}
                                                                userId={props?.userProfile?._id} 
                                                                userEmail={props?.userProfile?.email} 
                                                                userName={props?.userProfile?.name} 
                                                                userLastName={props?.userProfile?.lastName} 
                                                                billingDetail={billingDetail}
                                                            />
                                                            </Row >
                                                        }
                                                    </Col>
                                                        {!isProd() &&
                                                            failIns.length > 0
                                                            &&
                                                            <div className='mt-2'>
                                                                <small className='text-danger'> select to fail insurance for testing</small>
                                                                <ul>{failIns.map(i =>
                                                                    <li>
                                                                        <div className="check_box_wrapper cm_dark_check">
                                                                            <input
                                                                                onChange={() => updateFailQuoteIds(i.quote_id)}
                                                                                checked={quoteIds?.includes(i.quote_id)}
                                                                                type="checkbox"
                                                                                name="select" />
                                                                            <span className="check_box"><span></span> {i.product}-{i.name}</span>
                                                                        </div>
                                                                    </li>)

                                                                }
                                                                </ul>
                                                            </div>

                                                        }
                                                </Container>
                                                : ''
                                            }
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        }


                        <div className="row">
                            <div className="col-xl-11">
                                <div className="c_bor_b">
                                    <h4>Payment Method </h4>

                                    <Fragment>
                                          {acceptedInsuranceQuotes && Object.values(acceptedInsuranceQuotes).map((q, i) => (
                                            <div key={i} className="d-flex justify-content-end">
                                                <small>{q.type === 'gap-medical' ? 'Gap Medical Insurance' : 'Registration Insurance'} ({q?.eventName}):</small><b> ${(q?.total / 100).toFixed(2)}</b>
                                            </div>
                                          ))}
                                    </Fragment>

                                    <div className="d-flex justify-content-end">
                                        <p>Subtotal:</p><b> {campssubtotal > 0 ? `$${campssubtotal.toFixed(2)}` : '$0'}</b>
                                    </div>


                                    {
                                        copuonValue ? (
                                            <div className="d-flex justify-content-end">
                                                <p>Coupon Applied:</p><b>{copuonValue ? `-$${parseFloat(copuonValue).toFixed(2)}` : '$0'}</b>
                                            </div>
                                        ) : ''
                                    }

                                    {
                                        giftCartValue ? (
                                            <div className="d-flex justify-content-end">
                                                <p>Gift Card Applied:</p><b>-${giftCartValue}</b>
                                            </div>
                                        ) : ''
                                    }
                                </div>

                               {cartItems.length > 0 && 
                                <PaymentGateway
                                    cartItems={cartItems}
                                    isAlreadyBooked={isAlreadyBooked}
                                    allCampCodes={allCampCodes}
                                    copuonObj={{copuonValue, copuonName, discountArr, appliedCouponId}}
                                    giftCartObj={{giftCartValue, giftCartName}}
                                    cartIdsarr={cartIdsarr}
                                    is_payment_split={is_payment_split}
                                    billingDetail={billingDetail}
                                    insuranceTotal={insuranceTotal}
                                    insuranceQuotes={acceptedInsuranceQuotes.concat(declinedInsuranceQuotes)}
                                    insuranceOfferValidator={validateInsuranceOffers}
                                    grandtotal={grandtotal}
                                    totalProductsPrice={totalProductsPrice}
                                    isSlotAvailable={isSlotAvailable}
                                    slotAvailableMsg={slotAvailableMsg} 
                                    quoteIds={quoteIds}
                                    programCode={programCode}
                                    sourceMetadata={sourceMetadata}
                                    isTestDispute={!isProd() && !!disputeStatus}
                                    disputeStatus={!isProd() ? disputeStatus : ''}
                                    />}
                            </div>
                        </div>
                      

                    </div>
            }
        </div>
    )
}


const mapStateToProps = state => {
    let { loggedIn, userProfile } = state.user;
    let { isNewCardAdd } = state.ui;
    let itemsincart = state.cartReducer.cartitems;
    let camperList = state.program.camperList;
    return {
        loggedIn,
        isNewCardAdd,
        itemsincart,
        userProfile,
        camperList
    }
}

const mapDispatchToProps = dispatch => ({
    getitemsincart: (cartitems) => dispatch(getitemsincart(cartitems))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentConfirmation);